import { createContext, useState } from 'react'

export type DateTimeContextType = {
  inCustomerTimezone: boolean
  setInCustomerTimezone: React.Dispatch<React.SetStateAction<boolean>>
  toggleInCustomerTimezone: () => void
  enabled: boolean
}

export const DateTimeContext = createContext<DateTimeContextType>({
  inCustomerTimezone: false,
  setInCustomerTimezone: () => {},
  toggleInCustomerTimezone: () => {},
  enabled: false,
})

export const DateTimeContextProvider = ({
  customerTimeZone,
  children,
}: {
  customerTimeZone: string | null | undefined
  children: React.ReactNode
}) => {
  const [inCustomerTimezone, setInCustomerTimezone] = useState(false)
  const toggleInCustomerTimezone = () => setInCustomerTimezone(v => !v)
  const enabled = !!(
    customerTimeZone &&
    !compareTimeZones(customerTimeZone, Intl.DateTimeFormat().resolvedOptions().timeZone)
  )

  return (
    <DateTimeContext
      value={{
        inCustomerTimezone: inCustomerTimezone && enabled,
        setInCustomerTimezone,
        toggleInCustomerTimezone,
        enabled,
      }}
    >
      {children}
    </DateTimeContext>
  )
}

const compareTimeZones = (tz1: string, tz2: string) =>
  tz1 === tz2 || tz1.split('/').at(-1) === tz2.split('/').at(-1)
